import { useContext, useState} from 'react';
import {  Link } from 'react-router-dom';
import { ADMIN_ROUTE, BASKET_ROUTE, CONTACTS_ROUTE, DOCS_ROUTE, FORKLIT_ROUTE, HOMEPAGE_ROUTE, LOGIN_ROUTE, RENT_ROUTER, SERVICE_ROUTE, SHOP_ROUTE, VACANCIES_ROUTE } from '../utils/consts';
import { Button } from 'react-bootstrap';
import { Context } from '../index';
import { observer } from 'mobx-react-lite';
import logo from '../img/Уральский Деловой Центр.png';
import {useNavigate} from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import '../css/header.css';

const NavBar = observer(() => {
    const navigate = useNavigate();
    const {user} = useContext(Context);
    const [isActive, setIsActive] = useState(false);
    const click = () => {
        setIsActive(!isActive);
    }
    const close = () => {
      setIsActive(false);
    }
    const logOut = () => {
      user.setUser({})
      user.setIsAuth(false)
      localStorage.removeItem('token')
    }
    
    return(
        <div>
          <header>
            <div className="rectangle_header">
              <Link to={HOMEPAGE_ROUTE}><img className="logo" src={logo} alt="Уральский Деловой Центр" /></Link>
              <nav className={`nav-bar ${isActive ? 'active' : ''}`}>
                <ul className={`nav-menu ${isActive ? 'active' : ''}`}>
                  <li className='nav-item'><Link className='nav-link' to={SHOP_ROUTE} onClick={close}>Запчасти</Link></li>
                  <li className='nav-item'><Link className='nav-link' to={SERVICE_ROUTE} onClick={close}>Сервис</Link></li>
                  <li className='nav-item'><Link className='nav-link' to={RENT_ROUTER} onClick={close}>Аренда</Link></li>
                  <li className='nav-item'><Link className='nav-link' to={FORKLIT_ROUTE} onClick={close}>Погрузчики</Link></li>
                  {/*<li className='nav-item'><Link className='nav-link' to={DOCS_ROUTE} onClick={close}>Документы</Link></li>*/}
                  <li className='nav-item'><Link className='nav-link' to={CONTACTS_ROUTE} onClick={close}>Контакты</Link></li>
                  <li className='nav-item'><Link className='nav-link' to={VACANCIES_ROUTE} onClick={close}>Вакансии</Link></li>
                  {user.isAuth ? 
                    <>
                      <Button 
                        variant="light"
                        onClick={() => {logOut(); close();}}>
                        Выйти
                      </Button>
                      {user.isAuth && user.user?.role === 'ADMIN' && 
                        <Button
                          variant="light"
                          onClick={() => { navigate(ADMIN_ROUTE); close(); }}>
                          Админ панель
                        </Button>
                      }
                    </>
                    : 
                    <Button
                      variant="light"
                      className='auth-btn'
                      onClick={() => {navigate(LOGIN_ROUTE); close();}}>
                      Войти
                    </Button>
                  }
                      <Button
                      variant="light"
                      className='cart-button'
                      onClick={() => {navigate(BASKET_ROUTE); close();}}>
                      <FaShoppingCart /> Корзина
                    </Button>
                </ul>
                    <Button
                      variant="custom"
                      className='cart-button-mobile'
                      onClick={() => {navigate(BASKET_ROUTE); close();}}>
                      <FaShoppingCart color='white'/>
                    </Button>
                <div 
                className={`hamburger ${isActive ? 'active' : ''}`} 
                onClick={click}
                >
                  <span className='bar'></span>
                  <span className='bar'></span>
                  <span className='bar'></span>
                </div>
              </nav>
            </div>
          </header>
        </div>
        
    );
});
export default NavBar;
